import React from "react";
import { Link, useLocation } from "react-router-dom";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";

const Breadcrumb = () => {
  const location = useLocation();

  return (
    <>
      <div className="d-flex bread-crumb align-items-center ">
        <Link
          style={{ textDecoration: "none", color: "#fff" }}
          to="/exit/my-requests"
          className={` px-1 rounded   ${
            location.pathname.includes("/exit/my-requests") ? " active  " : " "
          }`}
        >
          <span className="text-truncate  menu-item">My Requests</span>
        </Link>
        <HorizontalRuleIcon className="rotated" />

        <Link
          style={{ textDecoration: "none", color: "#fff" }}
          to="/exit/rehabilitations"
          className={`  px-1 rounded  ${
            location.pathname.includes("/exit/rehabilitations") ? "active" : " "
          }`}
        >
          <span className="text-truncate  menu-item">Rehabilitations</span>
        </Link>
      </div>
    </>
  );
};

export default Breadcrumb;
